<script>
    import R, {LOADER} from "../lib/requests";
    import cart from "../stores/cart";
    import {address2Str, formatDate} from "../lib/lib";
    import Warning from "../components/pages/Warning.svelte";
    import Cart from "../cart/Cart.svelte";
    import {ORDER_STATUS, PAYMENT_METHOD, SHIPPING_METHOD} from "../lib/constants";

    export let hash;

    let order = null;
    let address = '';
    let notFound = false;

    const load = () => {
        const onSuccess = result => {
            order = result;
            order.products.map(item => {
                item.price = parseFloat(item.price);
            });
            order.products_price = parseFloat(order.products_price);
            order.shipping_price = parseFloat(order.shipping_price);
            order.vat_price = parseFloat(order.vat_price);
            order.cod_price = parseInt(order.cod_price);
            order.total_price = parseFloat(order.total_price);

            address = address2Str(order.address, order.postal_code, order.city);
            if (order.hash == $cart.order) {
                cart.clear();
            }
        }

        const onFailure = err => {
            if (err.code === 'not_found') {
                notFound = true;
            }
        };

        R.handle(R.order.details, {hash}, onSuccess, onFailure, LOADER.PAGE);
    }

    load();
</script>

{#if !notFound}
    {#if order != null}
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-pad-right">
                <div class="mb-5">
                    <h3 class="mb-3">Αρ. παραγγελίας: <span class="fw-normal text-gray">{ order.ref_id }</span>
                    </h3>
                    <hr>
                    <Cart products="{ order.products }"
                          vat="{ order.vat }"
                          productsPrice="{ order.products_price }"
                          shippingPrice="{ order.shipping_price }"
                          codPrice="{ order.cod_price }"
                          vatPrice="{ order.vat_price }"
                          totalPrice="{ order.total_price }"
                    />
                </div>
                {#if order.passports && order.passports.length}
                    <div class="alert alert-light mb-5">
                        <h6>Αρ. Διαβατηρίων</h6>
                        {#each order.passports as chunk}
                            <div>GR01{ chunk.passport_from } - GR01{ chunk.passport_to }</div>
                        {/each}
                    </div>
                {/if}

                {#if order.status_id == ORDER_STATUS.ON_PROGRESS}
                    <div class="alert alert-info mb-5">
                        Η παραγγελία είναι σε εξέλιξη.
                    </div>
                {:else if order.status_id == ORDER_STATUS.SENT}
                    <div class="alert alert-success mb-5">
                        Η παραγγελία έχει παραδοθεί στην μεταφορική εταιρία.
                    </div>
                {:else if order.status_id == ORDER_STATUS.COMPLETED}
                    <div class="alert alert-success mb-5">
                        Η παραγγελία έχει ολοκληρωθεί.
                    </div>
                {:else if order.status_id == ORDER_STATUS.RETURNED}
                    <div class="alert alert-danger mb-5">
                        Η παραγγελία έχει επιστραφεί.
                    </div>
                {:else if order.status_id == ORDER_STATUS.CANCELED}
                    <div class="alert alert-danger mb-5">
                        Η παραγγελία έχει ακυρωθεί.
                    </div>
                {/if}
            </div>
            <div class="col-xl-6 col-lg-6 col-pad-left mb-5">
                <h2 class="mb-4">{ order.lastname } { order.firstname }</h2>
                <div class="mb-4">
                    <h6>Α.Φ.Μ.</h6>
                    <div class="text-gray">{ order.afm }</div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-12 mb-4">
                        <h6>Τηλέφωνο</h6>
                        <div class="text-gray">{ order.phone }</div>
                    </div>
                    <div class="col-md-6 col-12 mb-4">
                        <h6>Email</h6>
                        <div class="text-gray">{ order.email }</div>
                    </div>
                </div>
                {#if order.shipping_method != SHIPPING_METHOD.STORE}
                    <div class="row">
                        <div class="col-md-6 col-12 mb-4">
                            <h6>Διεύθυνση αποστολής</h6>
                            <div class="text-gray">{ address }</div>
                        </div>
                        <div class="col-md-6 col-12">
                            <h6>Νομός</h6>
                            <div class="text-gray">{ order.region.name }</div>
                        </div>
                    </div>
                {/if}
                {#if order.bill_afm}
                    <hr>
                    <h5 class="mb-4">Στοιχεία Τιμολογίου</h5>
                    <div class="row">
                        <div class="col-md-6 mb-4">
                            <h6>Επωνυμία</h6>
                            { order.bill_name }
                        </div>
                        <div class="col-md-6 mb-4">
                            <h6>Τηλέφωνο</h6>
                            { order.bill_phone }
                        </div>
                        <div class="col-12 mb-4">
                            <h6>Διεύθυνση</h6>
                            { order.bill_address }
                        </div>
                        <div class="col-md-6 mb-4">
                            <h6>Α.Φ.Μ.</h6>
                            { order.bill_afm }
                        </div>
                        <div class="col-md-6 mb-4">
                            <h6>Δ.Ο.Υ.</h6>
                            { order.bill_doy }
                        </div>
                    </div>
                {/if}
                <hr>
                <div class="row">
                    <div class="col-md-6 col-12 mb-4">
                        <h6>Αρ. Παραγγελίας</h6>
                        <div class="text-gray">{ order.ref_id }</div>
                    </div>
                    {#if order.payment_id}
                        <div class="col-md-6 col-12 mb-4">
                            <h6>Αρ. Συναλλαγής</h6>
                            <div class="text-gray">{ order.payment_id }</div>
                        </div>
                    {/if}
                    <div class="col-md-6 col-12 mb-4">
                        <h6>Τρόπος πληρωμής</h6>
                        <div class="text-gray">
                            {#if order.payment_method == PAYMENT_METHOD.CARD}
                                Χρεωστική κάρτα
                            {:else if order.payment_method == PAYMENT_METHOD.BANK}
                                Κατάθεση σε τράπεζα
                            {:else}
                                Αντικαταβολή
                            {/if}
                        </div>
                    </div>
                    <div class="col-md-6 col-12 mb-4">
                        <h6>Ημερομηνία</h6>
                        <div class="text-gray">{ formatDate(order.created_at, 'd-m-y') }</div>
                    </div>
                    <div class="col-md-6 col-12 mb-4">
                        <h6>Αποστολή με</h6>
                        <div class="text-gray">
                            {#if order.shipping_method == SHIPPING_METHOD.COURIER}
                                {#if order.courier}
                                    {#if order.courier.link}
                                        <a href="{ order.courier.link}" target="_blank">{ order.courier.name }</a>
                                    {:else}
                                        { order.courier.name }
                                    {/if}
                                {:else}
                                    Courier
                                {/if}
                            {:else}
                                Παραλαβή από τα κεντρικά γραφεία
                            {/if}
                        </div>
                    </div>
                    {#if order.shipping_code}
                        <div class="col-md-6 col-12 mb-4">
                            <h6>Κωδικός αποστολής</h6>
                            <div class="text-gray">
                                { order.shipping_code }
                            </div>
                        </div>
                    {/if}

                </div>
                {#if order.payment_method == PAYMENT_METHOD.BANK}
                    <div class="mb-4">
                        <h6>Τραπεζικός λογαριασμός</h6>
                        <div class="text-gray">
                            Eurobank<br>
                            GR 8802600200000100200985232<br>
                            ΠΑΝΕΛΛΗΝΙΟΣ ΚΤΗΝΙΑΤΡΙΚΟΣ ΣΥΛΛΟΓΟΣ
                        </div>
                    </div>
                {/if}
            </div>
        </div>
    {/if}
{:else}
    <Warning warning="order-not-found"/>
{/if}
